import {
  Component,
  OnChanges,
  Input,
  ViewEncapsulation,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppService } from "src/app/app.service";
import { Dictionary } from "src/app/store/models/common_types";
import { AppState } from "src/app/store/state/app.state";
import Highcharts from "highcharts";

@Component({
  selector: "app-charts-plotter-container",
  templateUrl: "./charts-plotter-container.component.html",
  styleUrls: ["./charts-plotter-container.component.scss"],
  host: { class: "chart-container" },
  encapsulation: ViewEncapsulation.None,
})
export class ChartsPlotterContainerComponent implements OnChanges {
  @Input() selectedChart: string;
  @Input() chartFilters: Dictionary<string>;
  @Output() onChartInstance: EventEmitter<Highcharts.Chart> =
    new EventEmitter();
  dataToUse: Dictionary<any> = {};
  chartReady = false;
  legendShapes = [];

  legendColors = [];
  isEarning = false;
  isRevision = false;
  isSecondaryAxis;
  allowCombineAxis = true;
  axisChange = false;
  chartInfoBottom = "0px";
  chartInstance: Highcharts.Chart;
  isSecondaryAxisUpdateInProgress = false;

  constructor(
    private store: Store<AppState>,
    private appService: AppService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this.chartReady = false;
    this.axisChange = false;
    if (changes.chartFilters && changes.chartFilters.currentValue.scaleType) {
      // if (changes.chartFilters.currentValue.chartId === "suggested") {
      //   this.isSecondaryAxis = false;
      // } else {
      if (parseInt(changes.chartFilters.currentValue.scaleType, 10) !== 1) {
        this.axisChange = true;
        this.isSecondaryAxis = false;
        this.allowCombineAxis = true;
      } else {
        if (
          changes.chartFilters.currentValue.lines.length > 1 &&
          changes.chartFilters.currentValue.lineInfo[
            changes.chartFilters.currentValue.lines[0]
          ].unit ===
            changes.chartFilters.currentValue.lineInfo[
              changes.chartFilters.currentValue.lines[1]
            ].unit &&
          changes.chartFilters.currentValue.lineInfo[
            changes.chartFilters.currentValue.lines[0]
          ].magnitude ===
            changes.chartFilters.currentValue.lineInfo[
              changes.chartFilters.currentValue.lines[1]
            ].magnitude
        ) {
          this.axisChange = true;
          this.isSecondaryAxis = false;
          this.allowCombineAxis = true;
        } else {
          this.axisChange = true;
          this.isSecondaryAxis = true;
          this.allowCombineAxis = false;
        }
      }
      // }
    }
    switch (this.selectedChart) {
      case "charts-page-bar":
        this.legendColors = ["#304da5", "#a53088", "#412504"];
        this.legendShapes = ["circle"];
        this.dataToUse = {
          periods: this.chartFilters.periods,
          otherPeriods: this.chartFilters.otherPeriods,
          periodType: this.chartFilters.periodType,
          lines: this.chartFilters.lines,
          lineInfo: this.chartFilters.lineInfo,
          scaleType: this.chartFilters.scaleType,
          dataView: this.chartFilters.dataView,
          operation: this.getOperation(changes),
          tickers: this.chartFilters.tickers,
          selectedTickersInfo: this.chartFilters.selectedTickersInfo,
          seriesInfo: {},
          hoveredTicker: "",
          currency: this.chartFilters.currency,
          revision: this.chartFilters.revisionPeriod,
          chartTypeId: "1",
          legendColors: this.legendColors,
          legendShapes: this.legendShapes,
          isSecondaryAxis: this.isSecondaryAxis,
          chartName: this.chartFilters.chartName,
        };
        this.isEarning = false;
        this.isRevision = false;
        break;
      case "charts-page-revision":
        this.legendColors = [
          "#304da5",
          "#0f4040",
          "#a53088",
          "#d1d100",
          "#412504",
          "#6c30a5",
          "#073c5f",
          "#034c1a",
          "#871000",
          "#e88e82",

          "#9cade2",
          "#36abad",
          "#d275bb",
          "#e1e143",
          "#a87230",
          "#a575d2",
          "#1874ae",
          "#15813e",
          "#a61b08",
          "#f3bfb7",

          "#e6ebfc",
          "#82e5e6",
          "#f6d6ee",
          "#f4f4b1",
          "#eed7bb",
          "#e7d6f6",
          "#8bc3e3",
          "#66cd8f",
          "#c23824",
          "#fae1de",
        ];
        this.dataToUse = {
          periods: this.chartFilters.periods,
          otherPeriods: this.chartFilters.otherPeriods,
          periodType: this.chartFilters.periodType,
          lines: this.chartFilters.lines,
          lineInfo: this.chartFilters.lineInfo,
          scaleType: this.chartFilters.scaleType,
          operation: this.getOperation(changes),
          tickers: this.chartFilters.tickers,
          selectedTickersInfo: this.chartFilters.selectedTickersInfo,
          seriesInfo: {},
          hoveredTicker: "",
          currency: this.chartFilters.currency,
          revision: this.chartFilters.revisionPeriod,
          chartTypeId: "3",
          legendColors: this.legendColors,
          legendShapes: this.legendShapes,
          isSecondaryAxis: this.isSecondaryAxis,
          chartName: this.chartFilters.chartName,
        };
        this.isEarning = true;
        this.isRevision = true;
        break;
      case "charts-page-timeseries":
        this.legendColors = [
          "#304da5",
          "#0f4040",
          "#a53088",
          "#d1d100",
          "#412504",
          "#6c30a5",
          "#073c5f",
          "#034c1a",
          "#871000",
          "#e88e82",

          "#9cade2",
          "#36abad",
          "#d275bb",
          "#e1e143",
          "#a87230",
          "#a575d2",
          "#1874ae",
          "#15813e",
          "#a61b08",
          "#f3bfb7",

          "#e6ebfc",
          "#82e5e6",
          "#f6d6ee",
          "#f4f4b1",
          "#eed7bb",
          "#e7d6f6",
          "#8bc3e3",
          "#66cd8f",
          "#c23824",
          "#fae1de",
        ];
        this.dataToUse = {
          periods: this.chartFilters.periods,
          otherPeriods: this.chartFilters.otherPeriods,
          periodType: this.chartFilters.periodType,
          lines: this.chartFilters.lines,
          dataView: this.chartFilters.dataView,
          lineInfo: this.chartFilters.lineInfo,
          scaleType: this.chartFilters.scaleType,
          operation: this.getOperation(changes),
          tickers: this.chartFilters.tickers,
          selectedTickersInfo: this.chartFilters.selectedTickersInfo,
          seriesInfo: {},
          hoveredTicker: "",
          currency: this.chartFilters.currency,
          revision: this.chartFilters.revisionPeriod,
          chartTypeId: "2",
          legendColors: this.legendColors,
          legendShapes: this.legendShapes,
          isSecondaryAxis: this.isSecondaryAxis,
          chartName: this.chartFilters.chartName,
        };
        this.isEarning = true;
        this.isRevision = true;
        break;
      default:
        this.dataToUse = {};
    }
  }

  getOperation(changes: SimpleChanges) {
    if (
      changes.chartFilters &&
      changes.chartFilters.previousValue &&
      changes.chartFilters.previousValue.chartId &&
      changes.chartFilters.previousValue.chartId !==
        changes.chartFilters.currentValue.chartId
    ) {
      this.chartInfoBottom = "0px";
      return "fetchData";
    }
    if (
      changes.chartFilters &&
      changes.chartFilters.previousValue &&
      changes.chartFilters.previousValue.scaleType &&
      changes.chartFilters.previousValue.scaleType !==
        changes.chartFilters.currentValue.scaleType
    ) {
      if (
        (this.dataToUse.lines.length > 1 &&
          this.dataToUse.lineInfo[this.dataToUse.lines[0]].unit !==
            this.dataToUse.lineInfo[this.dataToUse.lines[1]].unit) ||
        this.axisChange
      ) {
        this.chartInfoBottom = "0px";
        return "fetchData";
      }

      return "updateScale";
    }
    if (
      changes.chartFilters &&
      changes.chartFilters.previousValue &&
      changes.chartFilters.previousValue.dataView &&
      changes.chartFilters.previousValue.dataView !==
        changes.chartFilters.currentValue.dataView
    ) {
      this.chartInfoBottom = "0px";
      return "fetchData";
    }
    this.chartInfoBottom = "0px";
    return "fetchData";
  }

  formatCell(data, currency, unit, valueType: string) {
    const sliCompsData = data;

    const valueToUse = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(sliCompsData);
    let unitType = unit;
    if (
      !currency ||
      valueType === "yoy" ||
      valueType === "revision" ||
      valueType === "index"
    ) {
      currency = "";
    }
    if (unitType === "%" && valueType !== "index") {
      unitType = valueType === "yoy" || valueType === "revision" ? "bps" : "%";
    } else {
      unitType = valueType === "yoy" || valueType === "revision" ? "%" : "";
    }

    return `${currency}${valueToUse}${unitType}`;
  }

  changeAxis(event) {
    this.isSecondaryAxisUpdateInProgress = true;
    this.dataToUse = {
      ...this.dataToUse,
      isSecondaryAxis: event,
    };

    // const meta = this.dataToUse;
    // const formatterFunction = this.formatCell;
    // this.chartInstance.options.series.forEach((s) => {
    //   if (s["custom"] && s["custom"]["parentLine"]) {
    //     s["isSecondaryAxis"] = event;
    //     if (event === true) {
    //       s.yAxis = this.dataToUse.lines.indexOf(s["custom"]["parentLine"]);
    //     } else {
    //       s.yAxis = 0;
    //     }
    //   }
    // });

    // if (event === true) {
    //   this.chartInstance.yAxis[0].update({
    //     title: {
    //       text: `${meta.lineInfo[meta.lines[0]].name} ${
    //         meta.lineInfo[meta.lines[0]].magnitude &&
    //         meta.lineInfo[meta.lines[0]].magnitude !== "" &&
    //         meta.lineInfo[meta.lines[0]].magnitude !== "Abs" &&
    //         meta.scaleType === 1
    //           ? `(in ${meta.lineInfo[meta.lines[0]].magnitude})`
    //           : ""
    //       }`
    //     },
    //     // max: meta.scaleType !== 1 ? 100 : null,
    //     labels: {
    //       formatter: function() {
    //         const formattedValue = formatterFunction(
    //           this.value,
    //           meta.lineInfo[meta.lines[0]].curr_symbol,
    //           meta.lineInfo[meta.lines[0]].unit,
    //           this.chart.userOptions.series[0]["scale"] === "index"
    //             ? this.chart.userOptions.series[0]["scale"]
    //             : this.chart.userOptions.series[0]["dv"]
    //         );
    //         return formattedValue;
    //       }
    //     }
    //   });
    //   if (this.chartInstance.yAxis.length > 1) {
    //     this.chartInstance.yAxis[1].update({
    //       title: {
    //         text: `${meta.lineInfo[meta.lines[1]].name} ${
    //           meta.lineInfo[meta.lines[1]].magnitude &&
    //           meta.lineInfo[meta.lines[1]].magnitude !== "" &&
    //           meta.lineInfo[meta.lines[1]].magnitude !== "Abs" &&
    //           meta.scaleType === 1
    //             ? `(in ${meta.lineInfo[meta.lines[1]].magnitude})`
    //             : ""
    //         }`,
    //         style: {
    //           fontSize: "14px",
    //           minWidth: "100px",
    //           maxWidth: "160px",
    //           textOverflow: "ellipsis",
    //           overflow: "hidden",
    //           whiteSpace: "nowrap"
    //         }
    //       },
    //       // max: meta.scaleType !== 1 ? 100 : null,
    //       visible: true,
    //       opposite: true,
    //       labels: {
    //         formatter: function() {
    //           const formattedValue = formatterFunction(
    //             this.value,
    //             meta.lineInfo[meta.lines[1]].curr_symbol,
    //             meta.lineInfo[meta.lines[1]].unit,
    //             this.chart.userOptions.series[1]["scale"] === "index"
    //               ? this.chart.userOptions.series[1]["scale"]
    //               : this.chart.userOptions.series[1]["dv"]
    //           );
    //           return formattedValue;
    //         }
    //       }
    //     });
    //   } else {
    //     this.chartInstance.addAxis({
    //       title: {
    //         text: `${meta.lineInfo[meta.lines[1]].name} ${
    //           meta.lineInfo[meta.lines[1]].magnitude &&
    //           meta.lineInfo[meta.lines[1]].magnitude !== "" &&
    //           meta.lineInfo[meta.lines[1]].magnitude !== "Abs" &&
    //           meta.scaleType === 1
    //             ? `(in ${meta.lineInfo[meta.lines[1]].magnitude})`
    //             : ""
    //         }`,
    //         style: {
    //           fontSize: "14px",
    //           minWidth: "100px",
    //           maxWidth: "160px",
    //           textOverflow: "ellipsis",
    //           overflow: "hidden",
    //           whiteSpace: "nowrap"
    //         }
    //       },
    //       // max: meta.scaleType !== 1 ? 100 : null,
    //       visible: true,
    //       opposite: true,
    //       labels: {
    //         formatter: function() {
    //           const formattedValue = formatterFunction(
    //             this.value,
    //             meta.lineInfo[meta.lines[1]].curr_symbol,
    //             meta.lineInfo[meta.lines[1]].unit,
    //             this.chart.userOptions.series[1]["scale"] === "index"
    //               ? this.chart.userOptions.series[1]["scale"]
    //               : this.chart.userOptions.series[1]["dv"]
    //           );
    //           return formattedValue;
    //         }
    //       }
    //     });
    //   }
    // } else {
    //   this.chartInstance.yAxis[0].update({
    //     title: {
    //       text: `${meta.lineInfo[meta.lines[0]].name} ${
    //         meta.lineInfo[meta.lines[0]].magnitude &&
    //         meta.lineInfo[meta.lines[0]].magnitude !== "" &&
    //         meta.lineInfo[meta.lines[0]].magnitude !== "Abs" &&
    //         meta.scaleType === 1
    //           ? `(in ${meta.lineInfo[meta.lines[0]].magnitude})`
    //           : ""
    //       }<br>
    //         ${
    //           meta.lineInfo[meta.lines[1]]
    //             ? `${meta.lineInfo[meta.lines[1]].name} ${
    //                 meta.lineInfo[meta.lines[1]].magnitude &&
    //                 meta.lineInfo[meta.lines[1]].magnitude !== "" &&
    //                 meta.lineInfo[meta.lines[1]].magnitude !== "Abs" &&
    //                 meta.scaleType === 1
    //                   ? `(in ${meta.lineInfo[meta.lines[1]].magnitude})`
    //                   : ""
    //               }`
    //             : ""
    //         }`,
    //       style: {
    //         fontSize: "14px",
    //         minWidth: "100px",
    //         maxWidth: "160px",
    //         textOverflow: "ellipsis",
    //         overflow: "hidden",
    //         whiteSpace: "nowrap"
    //       }
    //     },
    //     // max: meta.scaleType !== 1 ? 100 : null,
    //     labels: {
    //       formatter: function() {
    //         const formattedValue = formatterFunction(
    //           this.value,
    //           meta.lineInfo[meta.lines[0]].curr_symbol,
    //           meta.lineInfo[meta.lines[0]].unit,
    //           this.chart.userOptions.series[0]["scale"] === "index"
    //             ? this.chart.userOptions.series[0]["scale"]
    //             : this.chart.userOptions.series[0]["dv"]
    //         );
    //         return formattedValue;
    //       }
    //     }
    //   });

    //   this.chartInstance.yAxis[1].update({
    //     visible: false
    //   });
    // }

    this.chartInstance.redraw();
  }

  chartDataSet() {
    this.chartReady = true;
  }

  onChartInstanceChange(chartInstance: Highcharts.Chart) {
    if (chartInstance) {
      const cInstance = chartInstance;
      this.chartInstance = cInstance;
      this.chartInfoBottom = `${
        document.getElementsByClassName("highcharts-legend-box")[0]["height"][
          "baseVal"
        ]["value"] +
        30 +
        12
      }px`;
      this.onChartInstance.emit(chartInstance);
      // this.store.dispatch(new SetChartInstance(cInstance));
      this.isSecondaryAxisUpdateInProgress = false;
    }
  }
}
